<template>
  <li style="cursor: pointer;">
    <router-link
      :to="to"
      style="color: white;text-decoration: none;background: none;height: 44px;display: flex;align-items: center;justify-content: center;"
      active-class="admin-tool-active-navigation-item"
    >
      <span style="padding: 0px 20px;">{{ label }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  props: ['label', 'to'],
};
</script>

<style scoped>
.admin-tool-active-navigation-item {
  font-weight: bold;
  background-color: #F5F6F7 !important;
  color: #3b4054 !important;
}
</style>
